<template>
  <button
    @click="onClick"
    :class="['btn-follow', { 'followed': isFollow }]"
  >{{ $t(isFollow ? 'btn-follow.followed' : 'btn-follow.not-follow') }}</button>
</template>
<script>
import * as userApi from "~/api/user";
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import * as types from "~/types";

export default {
  props: {
    subjectId: Number,
    isFollow: Boolean
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", ["isFocus", "isLogin", "userId"])
  },
  methods: {
    focus() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      this.$axios(
        userApi.focusTheme({
          subjectId: this.subjectId
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this.$emit("success");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    unfocus() {
      if (!this.isLogin) {
        return;
      }
      this.$axios(
        userApi.cancelTheme({
          subjectId: this.subjectId
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this.$emit("success");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onClick() {
      if (this.isFollow) {
        this.unfocus();
      } else {
        this.focus();
      }
    },
    ...mapMutations("user", [types.FOCUS, types.UNFOCUS, types.SHOW_LOGIN_FORM])
  }
};
</script>
<style lang="less" scoped>
.btn-follow {
  box-sizing: border-box;
  width: 64px;
  height: 26px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3278d2;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #3278d2;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.followed {
  background: #98bbe8 !important;
  color: #fff;
  border: 1px solid #98bbe8;
}
</style>
